import { render, staticRenderFns } from "./Voucher-Unit.vue?vue&type=template&id=7318dcaa&scoped=true&"
import script from "./Voucher-Unit.vue?vue&type=script&lang=js&"
export * from "./Voucher-Unit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7318dcaa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7318dcaa')) {
      api.createRecord('7318dcaa', component.options)
    } else {
      api.reload('7318dcaa', component.options)
    }
    module.hot.accept("./Voucher-Unit.vue?vue&type=template&id=7318dcaa&scoped=true&", function () {
      api.rerender('7318dcaa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2l7sudHhlg5p9/JS/comp/Voucher-Unit.vue"
export default component.exports